import { useEffect } from "react";

export const useEscKeyPress = (callback=()=>{}) => {
  useEffect(() => {
    function handleKeyPress(event) {
      if (event.keyCode === 27) {
        callback()
      }
    }

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);
};
